import { lazyNamed } from 'src/utils/lazyNamed.ts';

export const PaymentMethods = {
  PaymentMethods: lazyNamed(() => import('./containers/PaymentMethods/index.tsx'), 'PaymentMethods'),
};
